import React from "react";
import { Sparkles, Heart } from "lucide-react";

// Tiny in-world object drawings keyed by find.key.
const ART = {
  kite: (
    <div className="relative h-6 w-6">
      <span className="absolute inset-0 rotate-45 bg-[#f4c542]"><span className="absolute inset-0 border border-[#7a5230]" /></span>
      <span className="absolute -bottom-1 right-1 h-3 w-[1px] rotate-12 bg-[#3a2617]" />
    </div>
  ),
  marble: (
    <div className="relative flex flex-col items-center">
      <span className="h-2 w-8 rounded-sm bg-[#8a6a3f]" />
      <span className="mt-[1px] h-1.5 w-9 rounded-sm bg-[#6e5334]" />
      <span className="absolute -bottom-1 left-1 h-2.5 w-2.5 rounded-full" style={{ background: "radial-gradient(circle at 35% 30%,#fff,#2A9D8F 60%,#1b6e63)" }} />
    </div>
  ),
  cassette: (
    <div className="flex h-5 w-8 items-center justify-center gap-1 rounded-[2px] border border-[#222] bg-[#2b2b2b]">
      <span className="h-2 w-2 rounded-full border border-white/60" />
      <span className="h-2 w-2 rounded-full border border-white/60" />
    </div>
  ),
  phantom: (
    <div className="h-1.5 w-8 rounded-full bg-white"><span className="block h-full w-2 rounded-l-full bg-[#e63946]" /></div>
  ),
  coin: (
    <span className="flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#a67c00] bg-gradient-to-b from-[#f4d160] to-[#c9a227] text-[7px] font-bold text-[#7a5b00]">50</span>
  ),
  pencil: (
    <div className="h-1.5 w-9 rotate-[-8deg] rounded-full bg-[#e63946]"><span className="block h-full w-1.5 rounded-l-full bg-[#f4c542]" /></div>
  ),
};

export const ObjectFind = ({ find, found, onClick }) => (
  <div className="absolute z-[22]" style={{ left: `${find.x}%`, top: `${find.y}%`, transform: "translate(-50%, -50%)" }}>
    <button
      data-testid={`find-${find.key}`}
      onClick={onClick}
      className="group relative flex flex-col items-center"
      aria-label={find.name}
    >
      {/* discover hint */}
      <div className="pointer-events-none absolute -top-6 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-md border border-kirana-brown bg-kirana-cream px-1.5 py-[1px] font-signboard text-[8px] font-bold text-kirana-brown opacity-0 shadow-[1px_1px_0_rgba(0,0,0,0.3)] transition-opacity group-hover:opacity-100">
        {found ? "Yaad ❤️" : "Kya hai ye?"}
      </div>
      <div className={`find-bob relative transition-transform group-hover:scale-110 ${found ? "opacity-80" : ""}`}>
        {ART[find.key]}
        {!found && (
          <Sparkles className="find-twinkle absolute -right-2 -top-2 h-3 w-3 text-kirana-gold drop-shadow-[0_0_3px_rgba(255,209,102,0.9)]" strokeWidth={2.5} />
        )}
        {found && (
          <span className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full border border-kirana-brown bg-kirana-cream">
            <Heart className="h-2.5 w-2.5 fill-kirana-red text-kirana-red" />
          </span>
        )}
      </div>
    </button>
  </div>
);
